import React, { useState } from "react";
import styles from "./index.module.scss";
import LanguageSwitcher from "../../LanguageSwitcher";

import Logo from "../../SVGs/Logo";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import assets from "../../../assets";

function HamburgerMenu({ light }) {
  const { t } = useTranslation();
  // VARIABLES
  const tabs = [
    {
      title: t("common.home"),
      link: "",
    },
    {
      title: t("common.about"),
      link: "about",
    },
    {
      title: t("common.projects"),
      link: "projects",
    },
    {
      title: t("common.contact"),
      link: "#contact",
    },
  ];

  const social = [
    {
      type: "facebookIcon",
      link: "https://web.facebook.com/Alhabashy.Group?mibextid=ZbWKwL&_rdc=1&_rdr",
    },
    {
      type: "linkedInIcon",
      link: "https://www.linkedin.com/company/alhabashy-group",
    },
    {
      type: "instgramIcon",
      link: "https://www.instagram.com/alhabashy_group/",
    },
  ];

  // STATES
  const [toogleMenu, setToogleMenu] = useState(false);
  // STORE STATES
  // HOOKS
  const { locale } = useParams();
  // METHODS
  const toogle = () => {
    if (!toogleMenu) {
      disableScroll();
    } else {
      enableScroll();
    }
    setToogleMenu((prev) => !prev);
  };

  function disableScroll() {
    // Get the current page scroll position
    const scrollTop = window.screenTop || document.documentElement.scrollTop;
    const scrollLeft = window.screenLeft || document.documentElement.scrollLeft;

    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }

  function enableScroll() {
    window.onscroll = function () { };
  }
  // EFFECTS
  // RENDER
  return (
    <>
      <nav
        className={`${styles.responsiveNav} ${light ? styles.light : undefined
          }`}
      >
        <a className={`${styles.responsiveNavLogo}`} href={"/"}>
          <Logo />
        </a>
        <LanguageSwitcher light={light} />
        <div onClick={toogle} className={styles.hamburgerMenu}>
          <p className={`${styles.line}`}></p>
        </div>
      </nav>
      <div
        className={`${styles.responsiveMenuOverlay} ${toogleMenu ? styles.responsiveMenuAnimation : undefined
          }`}
      >
        <div className={`${styles.responsiveMenu}`}>
          <div onClick={toogle} className={styles.hamburgerMenu}>
            <p className={`${styles.line} ${styles.lineHide}`}></p>
          </div>
          <ul className={styles.responsiveMenuList}>
            {tabs.map((tab, index) => (
              <li key={index} className={styles.responsiveMenuListItem}>
                {
                  <a onClick={toogle} href={`/${locale}/${tab.link}`}>
                    {tab.title}
                  </a>
                }
              </li>
            ))}
          </ul>
          {/* <div className={styles.social}>
            <p>{t("common.follow")}</p>
            <div>
              {social.map((social, index) => {
                return (
                  <a href={social.link} key={index}>
                    <img src={assets.icons[social.type]} alt={social.type} />
                  </a>
                );
              })}
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}
export default HamburgerMenu;
